export class IdpConfig {
  baseUrl: string
}
